import React from 'react'
import image1 from '../images/graduation1.jpeg'
import image2 from '../images/graduation2.jpeg'
import image3 from '../images/graduation3.jpeg'
import image4 from '../images/graduation4.jpeg'
import image5 from '../images/graduation5.jpeg'
import image6 from '../images/graduation6.jpeg'

export default function Graduations() {
  return (
    <div className='sub-gallery-images'>
      <img src={image1} alt='photo' className='sub-gallery-image'/>
      <img src={image2} alt='photo' className='sub-gallery-image'/>
      <img src={image3} alt='photo' className='sub-gallery-image'/>
      <img src={image4} alt='photo' className='sub-gallery-image'/>
      <img src={image5} alt='photo' className='sub-gallery-image'/>
      <img src={image6} alt='photo' className='sub-gallery-image'/>
    </div>
  )
}
